export const SYNC_ENQUEUE = 'SYNC_ENQUEUE';
export const SYNC_DEQUEUE = 'SYNC_DEQUEUE';
export const SYNC_CLEAR = 'SYNC_CLEAR';

export const ROOMS_UPDATE = 'ROOMS_UPDATE';
export const ROOMS_INVENTORY_UPDATE = 'ROOMS_INVENTORY_UPDATE';
export const ROOMS_CLEAR = 'ROOMS_CLEAR';
export const ROOMS_INVENTORY_CLEAR = 'ROOMS_INVENTORY_CLEAR';

export const TEAMS_UPDATE = 'TEAMS_UPDATE';
export const TEAMS_CLEAR = 'TEAMS_CLEAR';



// WEBPACK FOOTER //
// ./src/store/MutationTypes.js